
'use strict'

import { isMobileRes, isMobileDevice, setCookie, getCookie } from "../utils/Utils";
import ModalNewClient from "./ModalNewClient";
import Auth from "../libs/API/Auth";
import Brands from "../libs/API/Brands";
import introJs from "intro.js";
import Input from "../utils/Input";
import Notification from "./Notification";
import AlertConfirm from './AlertConfirm';

class ClientSelectorClass{
    constructor(){
        this.main = document.getElementById('client_selector');

        if(this.main == null){
            return;
        }

        this._brands = [];
        this._brandItems = [];

        this._list = this.main.querySelector('.brand-selector__list');
        this._loading = this.main.querySelector('.brand-selector__loading');

        this._actionBtn = this.main.querySelector('.action_btn');
        
        this._searchInput = new Input(this.main.querySelector('.search_input'));
        this._valueLabel = this.main.querySelector('.value_label');

        this._closeBtn = this.main.querySelector('.close_btn');

        this._modalNewClient = new ModalNewClient();
        this._newClientBtn = this.main.querySelector('.new_client_btn');
        
        this._currentBrandId = null;
        this._currentBrandName = null;
        this._introJs = null;
        
        this._isOpen = false;
        this._readOnly = false;
        this._newClientEnabled = false;
        this._showTutorial = false;
        
        this._noResults = this.main.querySelector('.brand-selector__no-search-result');
        this._noContent = this.main.querySelector('.brand-selector__no-content');

        this._closeBtn.addEventListener('click', this.hide.bind(this))
        this._newClientBtn.addEventListener('click', this.newClient.bind(this))
        this._searchInput.addEventListener('input', this._onSearchInputChange.bind(this));
        this._actionBtn.addEventListener('click', this._onClickActionBtn.bind(this));

        document.addEventListener('click', this._onClickDocument.bind(this));
        this.main.addEventListener('click', (e)=>{
            e.stopPropagation();
        });
        this.main.addEventListener('deleteClient', this._render.bind(this));
        this._modalNewClient.addEventListener('createClient', this._render.bind(this));
        this._modalNewClient.addEventListener('updateClient', this._render.bind(this));
        Auth.addEventListener('sessionReady',this._render.bind(this));

        this.loading = true;
    }

    show(){
        this._isOpen = true;
        
        this._searchInput.value = '';
        this._onSearchInputChange();
        
        if(isMobileDevice() || isMobileRes()){
            document.body.classList.add('block-scroll');
        }
        
        this.main.classList.add('brand-selector--open');

        setTimeout(() => {
            this.main.classList.add('brand-selector--open-anim');
        }, 0);

        this.hideTooltip();
        this.main.dispatchEvent(new CustomEvent('brandIsOpen'));
    }

    hide(){
        if (this._isOpen) {
            this.main.classList.remove('brand-selector--open', 'brand-selector--open-anim');
            document.body.classList.remove('block-scroll');
        }
        this._isOpen = false;
    }

    showExternalSellerTutorial(){
        let _this = this;
        this.hideTooltip();
        this._introJs = new introJs('#billboard_search');
        this._introJs.setOptions({
            overlayOpacity:0,
            exitOnEsc:false,
            exitOnOverlayClick: false,
            disableInteraction:true,
            steps: [{
                element: document.getElementById('client_selector'),
                intro: "We've created a demo client that allows you to experiment with adding billboards to your list and accessing summaries. You can either select the demo client here or create your own. This feature enables you to familiarize with the platform.",
                scrollTo:'tooltip',
                position: 'right'
            }, {
                element: document.getElementById('client_selector'),
                intro: "Each of your clients will be assigned to a particular category, such as beers, fast food, or soft drinks. This category influences the availability of billboards. Also, clients can choose to pay for exclusivity, which allows them to occupy certain billboards solely for their specific category.",
                scrollTo:'tooltip',
                position: 'right'
            }, {
                element: document.getElementById('client_selector'),
                intro: "You can only add billboards that belong to the same client at a time.",
                scrollTo:'tooltip',
                position: 'right'
            }
        ]
        }).onchange(function(targetElement) {
            if(targetElement && targetElement.classList.contains('brand-selector__box')){
                _this.show();
                _this._modalNewClient.hide();
            }else if(targetElement && targetElement.classList.contains('modal__content')){
                _this.newClient();
            }else{
                _this.hide();
                _this._modalNewClient.hide();
            }
        }).onexit(function(){
            if(getCookie('externalSellerTutorial') != 1) {
                setCookie('externalSellerTutorial', 1, 999);
            }
        }).start();
    }

    _clearList(){
        let options = this._list.querySelectorAll('.brand_item');
        options.forEach(element => {
            element.remove();
        });
    }

    set showTutorial(value){
        if(value) this._showTutorial = value;
    }

    get showTutorial(){
        return this._showTutorial;
    }

    set loading (value){
        if(value){
            this._list.classList.add('d-none');
            this._newClientBtn.classList.add('button--disabled');
            this._loading.classList.remove('d-none');
            this._searchInput.input.disabled = true;
        }else{
            this._list.classList.remove('d-none');
            this._newClientBtn.classList.remove('button--disabled');
            this._loading.classList.add('d-none');
            this._searchInput.input.disabled = false;
            this.main.dispatchEvent(new CustomEvent('loadingEnd'));
        }
    }

    _render(){
        if(getCookie('externalSellerTutorial') != 1 && this.showTutorial) {
            this.showExternalSellerTutorial();
        }
        this._clearList();
        this.loading = true;
        let params = {
            "filter[is_active]": 1,
            "page_size": 1000,
            "sort": '-is_demo,name',
        };
        Brands.getBrands(params).then((response)=>{
            this._brands = response.items;
            if(response.items.length>0){
                this._noContent.classList.add('d-none');
                response.items.forEach(element => {
                    let name = element.name.includes('-')
                      ? element.name
                      : element.organization.name + ' - ' + element.name;
                    this._list.insertAdjacentHTML('beforeend', `
                    <li class="brand-selector__item brand_item d-flex flex-row d-none" data-id="${element.id}" data-name="${name}">
                        <div class="w-100 flex-grow-1">
                            <div class="brand_name">${name}</div>
                            <span class="d-flex">${element.brand_category.name}</span>
                        </div>
                        ${!element.is_demo ? 
                        `<div class="my-auto d-flex brand-selector__actions">
                            ${element.organization.customer == null ? `<i class="material-icons material-icons--type-outlined material-icons--size-3 mr-2 edit_brand_item">edit</i>`:``}
                            <i class="material-icons material-icons--type-outlined material-icons--size-3 mr-2 delete_brand_item">delete</i>
                        </div>`: ``}
                    </li>
                    `);
                });
                Array.from(this.main.querySelectorAll('.brand_item')).forEach((brandItem)=>{
                    this._brandItems.push(brandItem);
                    brandItem.addEventListener('click', this._onClickBrandItem.bind(this));
                });
                this.loading = false;
            }else{
                this.loading = false;
                this._noContent.classList.remove('d-none');
                this._list.classList.add('d-none');
                this._searchInput.input.disabled = true;
            }
            
        });
    }

    newClient(e = null) {
        if(e) e.preventDefault();
        this.hide();
        this._modalNewClient.show();
    }

    editClient(values) {
        this.hide();
        this._modalNewClient.show(values);
    }

    deleteClient(id, name) {
        AlertConfirm.show({
            icon: 'warning',
            title: `Are you sure you want to <br>delete "${name}"?`,
            description: `This action cannot be undone.`,
            cancelBtn: {
                text: 'Cancel',
            },
            acceptBtn: {
                text: 'Delete',
                type: 'button',
                color: 'red-500',
            }
        }).then((resolve) => {
            if (resolve) {
                Brands.deleteClient(id).then(response => {
                    Notification.show('Client deleted', 'done');
                    this.main.dispatchEvent(new CustomEvent('deleteClient'));
                });
            } else {
                AlertConfirm._hide();
            }
        });
    }

    clear(){
        this.value = null;
        this._currentBrandId = null;
        this._currentBrandName = null;
        this._searchInput.value = '';
        this._onSearchInputChange();
    }
    
    set value(brandId){
        this._currentBrandId = brandId;

        let brandItem = this.main.querySelector(`.brand_item[data-id="${this._currentBrandId}"]`);

        if(brandItem != null){
            this._currentBrandName = brandItem.getAttribute('data-name');
            
            this._valueLabel.innerHTML = brandItem.querySelector('.brand_name').textContent;
            this.main.classList.add('brand-selector--filled');
        }else{
            this._currentBrandId = null;
            this._currentBrandName = null;

            this._valueLabel.innerHTML = 'My client';
            this.main.classList.remove('brand-selector--filled');
        }
        
    }

    get value(){
        return this._currentBrandId;
    }

    get name(){
        return this._currentBrandName;
    }

    get isOpen() {
        return this._isOpen;
    }

    set newClientEnabled(value) {
        this._newClientEnabled = value;
        if (value) {
            this._newClientBtn.classList.remove('d-none');
        } else {
            this._newClientBtn.classList.add('d-none');
        }
    }

    setValueDispatchingEvent(brandId) {
        this.value = brandId;
        this.main.dispatchEvent(new CustomEvent('brandChange'));
    }

    getBrandsCount() {
        return this._brandItems.length;
    }

    getBrandByIndex(index){
        let item = this._brandItems[index];
        
        return {id: item.dataset.id, name: item.dataset.name};
    }

    set actionButtonSize(size = 'big'){
        this._actionBtn.classList.remove('form-input-box-actionable--size-2');
        this._actionBtn.classList.remove('form-input-box-actionable--size-3');

        switch(size) {
            case 'small':
                this._actionBtn.classList.add('form-input-box-actionable--size-3');
            break;   
            case 'medium':
                this._actionBtn.classList.add('form-input-box-actionable--size-2');
            break;  
            case 'big':
            default:
            break;        
        }
    }

    set readOnly(readOnly){
        this._readOnly = readOnly;
        
        if(this._readOnly){
            this.main.classList.add('brand-selector--disabled');
        }else{
            this.main.classList.remove('brand-selector--disabled');
        }
    }

    showTooltip(){
        this.main.classList.add('brand-selector--show-tooltip');
    }

    hideTooltip(){
        this.main.classList.remove('brand-selector--show-tooltip');
    }

    addEventListener(event, callback){
        this.main.addEventListener(event, callback);
    }

    _onClickActionBtn(e){
        if(!this._readOnly){
            if(this._isOpen){
                this.hide();
            }else{
                this.show();
            }
        }
    }

    _onSearchInputChange(e = null){
        let search = this._searchInput.value.trim();
        let hasResult = false;
        
        Array.from(this.main.querySelectorAll('.brand_item')).forEach((brandItem)=>{
            if(search == '' || brandItem.textContent.toUpperCase().indexOf(search.toUpperCase()) != -1){
                brandItem.classList.add('d-flex')
                hasResult = true;
            }else{
                brandItem.classList.remove('d-flex')
            }
        });
        

        if(hasResult){
            this._noResults.classList.add('d-none');
        }else{
            if(search != ''){
                this._noResults.classList.remove('d-none');
            }
        }
    }

    _onClickBrandItem(e){
        if (e.currentTarget !== e.target && e.target.classList.contains('edit_brand_item')) {
            const id = e.currentTarget.getAttribute('data-id');
            const brand = this._brands.filter((brand) => brand.id == id)[0];
            this.editClient({
                id: brand.id,
                typeClient: brand.customer.type,
                brandCategoryId: brand.brand_category.id,
                companyName: brand.customer.company_name,
                productName: brand.name,
                firstName: brand.customer.first_name,
                lastName: brand.customer.last_name,
                email: brand.customer.email,
                telephone: brand.customer.phone,
                ein: brand.customer.tax_id
            });
            return;
        }
        if (e.currentTarget !== e.target && e.target.classList.contains('delete_brand_item')) {
            const id = e.currentTarget.getAttribute('data-id');
            const brand = this._brands.filter((brand) => brand.id == id)[0];
            this.deleteClient(brand.id,  brand.organization.name + ' - ' + brand.name);
            return;
        }

        this.value = e.currentTarget.getAttribute('data-id');

        this.hide();

        this.main.dispatchEvent(new CustomEvent('brandChange'));
    }

    _onClickDocument(e) {
        this.hide();
    }
}

const ClientSelector = new ClientSelectorClass();
Object.seal(ClientSelector);

export default ClientSelector;